export default __webpack_public_path__ + "static/media/cemerem_case.d426b8c6.jpeg";